import { Box, Button, Chip, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { Circle as CircleIcon, Check as CheckIcon } from "@mui/icons-material";
import { TaskEnumsLists } from "../../../../common/constants";
import { GetEstimatedUrgencyColor } from "../../../../common/mission";
import { useDispatch } from "../providers/DispatchProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      background: theme.palette.background.default,
      padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
      borderRadius: theme.spacing(2)
    },
    urgencyButtonBox: {
      background: theme.palette.background.grey,
      borderRadius: theme.spacing(1),
      padding: "4px"
    },
    button: {
      marginLeft: theme.spacing(0.25),
      marginRight: theme.spacing(0.25),
      paddingLeft: "4px",
      paddingRight: "4px",
      minWidth: "48px",
      height: "40px",
      borderRadius: "6px !important",
      transition: "background 250ms",
      "& .MuiButton-icon": {
        marginRight: "4px"
      }
    },
    activeButton: {
      background: theme.palette.background.default,
      fontWeight: 600
    },
    inActiveButton: {
      color: theme.palette.text.secondary,
    },
    slimSpan: {
      fontWeight: 400
    },
    planningFilter: {
      width: "200px"
    },
    planningSelectInput: {
      zIndex: 99999
    }
  })
);


export default function UrgencyToolbar(props) {
  const { compactMode } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();

  const {
    urgencyFilter,
    setUrgencyFilter,
    planningFilter,
    setPlanningFilter,
    lowPriorityFilter,
    setLowPriorityFilter,
    normalPriorityFilter,
    setNormalPriorityFilter,
    highPriorityFilter,
    setHighPriorityFilter,
    planningFilters,
    urgencyCounts,
    activeTasks,
  } = useDispatch();


  return (
    <Box className={classes.root}>
      <Grid container spacing={2}>

        <Grid item md={12} lg={12} xl>
          <Box className={classes.urgencyButtonBox}>
            <Stack direction="row" spacing={0.5}>

              <Tooltip title={t("common:all")}>
                <Button className={`${classes.button} ${urgencyFilter === null ? classes.activeButton : classes.inActiveButton}`} onClick={() => setUrgencyFilter(null)}>
                  <span className={classes.slimSpan}>{t("common:all")}</span>&nbsp;{activeTasks.length}
                </Button>
              </Tooltip>

              {TaskEnumsLists.EstimatedUrgency.map((u, val) => <UrgencyButton t={t} key={val} onClick={setUrgencyFilter} urgency={val} urgencyFilter={urgencyFilter} count={urgencyCounts[val]} />).reverse()}

            </Stack>
          </Box>
        </Grid>

        {
          !compactMode ? (
            <Grid item sx={{
              display: {
                xs: "none",
                xl: "block"
              }
            }}>
              <Divider orientation="vertical" sx={{ height: "48px" }} />
            </Grid>
          ) : null
        }


        <Grid item>
          <FormControl fullWidth size="small" variant="filled" className={classes.planningFilter}>
            <InputLabel>{t("mission:cards:tasks:planning:label")}</InputLabel>
            <Select
              onChange={ev => setPlanningFilter(ev.target.value)}
              value={planningFilter}
              MenuProps={compactMode ? { style: { zIndex: 9999 } } : undefined}

            >
              <MenuItem value={-1}>{t("common:all")}</MenuItem>
              <Divider />
              {planningFilters.map((filter, value) => <MenuItem value={value} key={value}>{filter.label}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>


        <Grid item sx={{
          display: {
            xs: "none",
            xl: "block"
          }
        }}>
          <Divider orientation="vertical" sx={{ height: "48px" }} />
        </Grid>

        <Grid item md={6} lg>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="textSecondary">{t("task:urgency:priority")}</Typography>
            <Stack direction="row" spacing={0.5}>
              <Chip
                size="small"
                label={t("task:enums:priority:High")}
                onClick={() => setHighPriorityFilter(v => !v)}
                variant={highPriorityFilter ? "filled" : "outlined"}
                icon={highPriorityFilter ? <CheckIcon /> : undefined}
              />
              <Chip
                size="small"
                label={t("task:enums:priority:Normal")}
                onClick={() => setNormalPriorityFilter(v => !v)}
                variant={normalPriorityFilter ? "filled" : "outlined"}
                icon={normalPriorityFilter ? <CheckIcon /> : undefined}
              />
              <Chip
                size="small"
                label={t("task:enums:priority:Low")}
                onClick={() => setLowPriorityFilter(v => !v)}
                variant={lowPriorityFilter ? "filled" : "outlined"}
                icon={lowPriorityFilter ? <CheckIcon /> : undefined}
              />
            </Stack>
          </Stack>
        </Grid>

      </Grid>
    </Box>
  );
}

function UrgencyButton(props) {
  const { urgency, urgencyFilter, onClick, count, t } = props;
  const { classes } = useStyles();
  const color = GetEstimatedUrgencyColor(urgency);

  return (
    <Tooltip title={t(`task:enums:estimatedUrgencyAlternate:${TaskEnumsLists.EstimatedUrgency[urgency]}`)}>
      <Button
        className={`${classes.button} ${urgency === urgencyFilter ? classes.activeButton : classes.inActiveButton}`}
        startIcon={<CircleIcon sx={{ color }} />}
        onClick={() => onClick(urgency)}
        TouchRippleProps={{
          style: { color },
        }}
      >
        {count}
      </Button>
    </Tooltip>
  );
}



